// extracted by mini-css-extract-plugin
module.exports = {"btn":"PrimaryButton_btn__KaOO0","secondary":"PrimaryButton_secondary__Uj9tK","iconLeft":"PrimaryButton_iconLeft__Q4251"};